<template>
  <main class="singapore">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
    <partners />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/singapore25/menu.vue';
import hero from '@/components/singapore25/hero.vue';
import agenda from '@/components/singapore25/agenda.vue';
import sponsors from '@/components/singapore25/sponsors.vue';
import speakers from '@/components/singapore25/speakers.vue';
import partners from '@/components/singapore25/partners.vue';
import presenters from '@/components/singapore25/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    partners,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .singapore {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>